/*eslint-disable*/
import React from "react";
import logo from "assets/img/OB-Lulu-Briggs-Logo.png";
// reactstrap components
import { Container, Row } from "reactstrap";
import "./footer.css";

import { Form, FormGroup, Input } from "reactstrap";
import { useSelector } from "react-redux";

function DarkFooter() {
  const charity = useSelector((state) => state.__charity.info);
  return (
    <footer className="footer footer-crowd" data-background-color="white">
      <Container>
        <Row>
          <div className="col-lg-3 col-md-6">
            <div className="footer-logo mb-3">
              <img src={logo} alt="Logo" style={{ maxWidth: "80%" }} />
            </div>
            <p className="" style={{ fontSize: "18px", color: "#000" }}>
              O.B. Lulu-Briggs Foundation's vision is a world where people are
              free from despair.
            </p>
            <div className="social-icon">
              <a
                href="https://www.facebook.com/oblbf/"
                target="_blank"
                class="btn-neutral btn-icon btn btn-facebook btn-lg"
              >
                <i class="fab fa-facebook-square"></i>
              </a>
              <a
                href="https://twitter.com/OBLBF"
                target="_blank"
                class="btn-neutral btn-icon btn btn-twitter btn-lg"
              >
                <i class="fab fa-twitter-square"></i>
              </a>
              <a
                href="https://www.instagram.com/oblbf_/?hl=en"
                target="_blank"
                class="btn-neutral btn-icon btn btn-instagram btn-lg"
              >
                <i class="fab fa-instagram"></i>
              </a>
              <a
                href="https://linkedin.com/company/oblbf"
                target="_blank"
                class="btn-neutral btn-icon btn btn-linkedin btn-lg"
              >
                <i class="fab fa-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="col-lg-2 col-md-6">
            <h4>Quick Links</h4>
            <ul className="list-unstyled">
              <li>
                <a href="/home">Home</a>
              </li>
              <li>
                <a href="/work">our work</a>
              </li>
              <li>
                <a href="/about/us">about</a>
              </li>
              <li>
                <a href="/about/image">Gallery</a>
              </li>
              <li>
                <a href="/news">Current news</a>
              </li>
              <li>
                <a href="/about/volunteer">Volunteers </a>
              </li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h4>Current News </h4>
            <ul className="list-unstyled">
              <li>
                <a href="/news/1645025825">20th Anniversary celebration</a>
              </li>
              <li>
                <a href="/news/1645022452">2 decades of improving the lives</a>
              </li>
              <li>
                <a href="/news/1645022523">Nigerian law school academic year</a>
              </li>
              <li>
                <a href="/news/1645019429">
                  Seinye lulu-briggs appointed chair of int'l fund
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-4 col-md-6">
            <h4>Contact</h4>
            <div className="footer-contact mb-3 mt-4">
              <span className="fa fa-map-marker pr-2" /> 17/23 Igbodo Street Old
              G.R.A, Port-Harcourt, Rivers State.
            </div>
            <div className="footer-contact mb-3">
              <span className="fa fa-envelope pr-2" />
              <a
                href="mailto: info@oblulubriggsfoundation.org"
                style={{ fontSize: "16.8px", color: "#000" }}
              >
                {charity?.c?.e?.i || "info@oblulubriggsfoundation.org"}
              </a>
              {/* {charity?.c?.e?.i||"info@oblulubriggsfoundation.org"} */}
            </div>
            <div className="footer-contact pr-2">
              <span className="fa fa-phone" /> +23484847781 +234706 855 5089
            </div>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default DarkFooter;
